import React, { useEffect, useState } from 'react';
import { store } from 'react-notifications-component';
import api from '../../services/api';
import googlemaps from '../../services/googlemaps';
import { apiprevmet3 } from '../../services/inmet_api';
import { AreaInfo, Card, Col5, Loading, Row, Text, TextDirection, Title, CarouselStyle } from './style';
import Carousel from "react-multi-carousel";
export const AGRORECEITA_USER_INFO_LOCATION = '@agroreceita_user_info_location';

const Week = ({ ...props }) => {

    const [previsao, setPrevisao] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');
    const [objKeys, setObjKeys] = useState([]);
    const [loading, setLoading] = useState(false);


    const getPrevisaoTempo = async (ibge) => {
        try {
            setLoading(true)
            const response = await apiprevmet3.get(`/previsao/${ibge}`);

            if (response) {
                setLoading(false)
                let prev = response.data;
                setPrevisao(prev[ibge]);

                let keys = Object.keys(prev[ibge]);
                setObjKeys(keys)
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
            // store.addNotification({
            //     title: "Erro!",
            //     message: "Erro INMET",
            //     type: "danger",
            //     insert: "top",
            //     container: "top-right",
            //     animationIn: ["animated", "fadeIn"],
            //     animationOut: ["animated", "fadeOut"],
            //     dismiss: {
            //         duration: 4000,
            //         onScreen: true
            //     }
            // });
        }
    }

    const getIBGE = async (cidade, estado) => {
        setLoading(true)

        try {
            const response = await api.post(`/ibge`, { cidade, estado });

            if (response) {
                let ibge = response.data.data.codigo;
                setLoading(false)
                getPrevisaoTempo(ibge);

            } else {
                setLoading(true)
                store.addNotification({
                    title: "Erro!",
                    message: "Erro ao buscar IBGE",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } catch (error) {
            // store.addNotification({
            //     title: "Erro!",
            //     message: `${error.response.data.error}`,
            //     type: "danger",
            //     insert: "top",
            //     container: "top-right",
            //     animationIn: ["animated", "fadeIn"],
            //     animationOut: ["animated", "fadeOut"],
            //     dismiss: {
            //         duration: 4000,
            //         onScreen: true
            //     }
            // });
        }
    }

    const saveLocation = async (lat, lng) => {
        const response = await googlemaps.get(`json?latlng=${lat},%20${lng}&sensor=true&key=AIzaSyAn3UaVotrho9E6f_BWtW4wDshxnEmM8LI`);

        console.log(response);

        if (response.data.results[1]) {
            let address = response.data.results[1].formatted_address;

            if (address) {
                address = address.split(',');

                if (address.length === 5) {
                    address = address[2];
                    address = address.split('-');

                    if (address.length === 2) {
                        let cidade = address[0].trim();
                        let estado = address[1].trim();

                        const validade = new Date();

                        localStorage.setItem(AGRORECEITA_USER_INFO_LOCATION, JSON.stringify({
                            cidade,
                            estado,
                            validade
                        }));

                        setCidade(cidade);
                        setEstado(estado);
                        getIBGE(cidade, estado);
                    } else {
                        const userInfoLocation = JSON.parse(localStorage.getItem(AGRORECEITA_USER_INFO_LOCATION));
                        if (userInfoLocation) {
                            const cidade = userInfoLocation.cidade;
                            const estado = userInfoLocation.estado;

                            setCidade(cidade);
                            setEstado(estado);
                            getIBGE(cidade, estado);
                        }
                    }
                } else {
                    const userInfoLocation = JSON.parse(localStorage.getItem(AGRORECEITA_USER_INFO_LOCATION));
                    if (userInfoLocation) {
                        const cidade = userInfoLocation.cidade;
                        const estado = userInfoLocation.estado;

                        setCidade(cidade);
                        setEstado(estado);
                        getIBGE(cidade, estado);
                    }
                }
            }
        }
    }

    const getWeek = async () => {
        try {
            const userInfoLocation = JSON.parse(localStorage.getItem(AGRORECEITA_USER_INFO_LOCATION));
            let lat = '';
            let lng = '';

            if (userInfoLocation) {
                //Validar validade da ultima checagem.
                //Utilizar a rota do google somente uma vez ao dia, para isso foi criado esse esquema de 'cache' para que o sistema leia o endereço salvo em memoria
                const then = new Date(userInfoLocation.validade);
                const now = new Date();

                const msBetweenDates = Math.abs(then.getTime() - now.getTime());
                const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

                if (hoursBetweenDates < 24) {
                    const cidade = userInfoLocation.cidade;
                    const estado = userInfoLocation.estado;

                    setCidade(cidade);
                    setEstado(estado);
                    getIBGE(cidade, estado);
                } else {

                    if ('geolocation' in navigator) {
                        navigator.geolocation.getCurrentPosition(function (position) {
                            lat = position.coords.latitude;
                            lng = position.coords.longitude;

                            saveLocation(lat, lng);
                        }, function (error) {
                        })
                    } else {
                    }
                }
            } else {
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        lat = position.coords.latitude;
                        lng = position.coords.longitude;

                        saveLocation(lat, lng);
                    }, function (error) {
                    })
                } else {
                }
            }
        } catch (error) {

        }
    }
    
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

    useEffect(() => {
        getWeek();
    }, [])

    return (
        <Card
            width={props.width ? props.width : ''}
            height="270px"
        >

            {loading ? (
                <div><Loading/></div>
            ) : (
                objKeys.length > 0 && previsao ? (
                    <CarouselStyle>
    
                        <Carousel
                            swipeable={true}
                            draggable={false}
                            showDots={true}
                            responsive={responsive}
                            ssr={true} // means to render carousel on server-side.
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={5000}
                            keyBoardControl={true}
                            // customTransition="all ."
                            transitionDuration={1000}
                            containerClass="carousel-container"
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                            deviceType={true}
                            dotListClass="custom-dot-list-style"
                            itemClass="carousel-item-padding-40-px"
                        >
                            {objKeys.map((key, i) => (
                                <>
                                    {i < 2 ? (
                                        <>
                                            <div style={{ 
                                                height: "250px",
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly'
                                            }}>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div><img width="80px" src={`${previsao[key].tarde.icone}`}></img></div>

                                                    <div>
                                                        <div className="text"><b>{previsao[key].tarde.dia_semana}</b></div>

                                                        <div className="min-max">
                                                            <img style={{ width: '30px', marginRight: '-10px', transform: 'rotate(180deg)' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAABmJLR0QA/wD/AP+gvaeTAAACE0lEQVR4nO3Xu2sUURgF8PPdCeujkIgEkspiNxEhzZqd6IaAjX+BjaAIirhJ/oR0ESzFYiE4u8WGQMTOQtFC7CQIeRQWCu5dURAsBIsUgq5kPoukGMOMz5l7g5xft/fO/fZw9jkAERERERERERERERXqdNMe8Z0BAIzXZ19QMxHZle0StmpRtwVV8RnHaxkTw72bAlzaeSSNWrs37zOPt1cijLpXFdLZs6yiuLw+N3rXRyYvZYRte1ZjPAFQStn+ApVzG3OVVde5nJdxarF7MghkVYGjP7nskzFmaq1R7joLBsffGdWOHTKBPPxFEQBwLI7jx9WOHXISbJezMuq33x8a6OMBgPJvHikHfb1fadoDReZKclPGgppvh7+uKHDmzw7K9GAJy65+cp2UURvp3QL0/F8evxBGb27kGihD4Y2Hd3rXVbT9r3NU5MrmTGU5j0xZCi1jMrL1GHgGIMhhXN8gnlybPfEih1mpCv2YxKLTyKcIAChtQ+o5zUo1UORwhS4JTBUaVwCz9cPmTlEHU459hsrzPdcOAngFCe4VFhYe/47XWvYdFMdTtl5uzI6OOw8E33et+wzLSGAZCSwjgWUksIwElpHgrwxFnLGTtV44n+8Mm7H+2mmKBG9lqGgzddloy3mYXd7K2JwZewTFNQE+AgAUH6Bycb0x9tRXpn0hXHw77DsDERERERERERER0f/uOxD7gnKnWy8VAAAAAElFTkSuQmCC"></img>
                                                            {previsao[key].tarde.temp_min}°
                                                            <img style={{ width: '30px', marginRight: '-10px' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAABmJLR0QA/wD/AP+gvaeTAAACEklEQVR4nO3XvWtTURzG8e+5t9YWRHSQGhUc6iK4uKipuergEpssggiKoIj+D24VHJ3c6lApVNwcSqMgbknooIuDghZBEJK20qGgUEp7fy6lXOUW33LPKfJ8xt95ycNzyRuIiIiIiIiIiIiISKGWqid3h84AEIV8cRsjmq8lU6vxjuX5emXcwIXME7SM7uvknmFXAcy4vTCa3AmZJ9iT6NYqN4CJn8Zm2LUDM+3HITIFKaNbT85i9gLoz1leSSN3/uB0s+07l/cyOqNnjjqXtoG9W+9yS+upjRx61vrgLRiey+hWk3302SzG8C83Oz6y5sql580vHqIBHj9AP18qDxLb9G8VAWAME9vTuWp1Z8HRNnkpw8aI+lbiKeDUHx6t7Iq/Tvr6yvVSxsKr0/cxLv7dabs8X0/u9jZRvsIb79SSWw57+M8XmV0vNdqTPYi0pULLWKiNlFOiJhD34LrVCE4MzbTe9OCuXIW+TVLiCr0pAqB/HSv36K5cfUVebi5+RLp23Dl3xLDl7JqDCjCQc+ybwewPe409ON4NrAw+KTJvyJ/jn4DDOUtvSzOtY77zQOA/atuNyshQGRkqI0NlZKiMDJWREbKMNHfqtph7EKwMh5vLXTDee46yKVgZZjzIG0fGuPcwG4KVUWo0G864CSxujDrO3JWhRutlqEzbwuKFc/tDZxARERERERERERH5330H6cWGuszNy3AAAAAASUVORK5CYII="></img>
                                                            {previsao[key].tarde.temp_max}°
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="resumo"><b>{previsao[key].tarde.resumo}</b></div>

                                                <hr width="90%"></hr>

                                                <div className="umidade-vento">
                                                    <div className="umidade">
                                                        <img style={{ width: '16px', paddingRight: '5px' }} src="data:image/png;base64,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" />
                                                        Min: {previsao[key].tarde.umidade_min}% - Max: {previsao[key].tarde.umidade_max}%
                                                    </div>
                                                    
                                                    <div className="vento">
                                                        <img style={{ width: '17px' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEs0lEQVR4nO2aS2wbVRSG/zN+JVGo0kiVWFAo1E6pTHgodppGogRCKFSCZQQbJBSIbUAgBUTUBVUFC0olHopa1Y6CWEbqig2PpiHQSMhO7YgKYag6CQQqWBSJRpDGjR9zWMRpx9PYM2OPEzvcb3fPnMe9Z+beuTPnAgKBQCAQCP6v0GZ3QI+OyHy7pPCLTNwLYFdevMCgSWKMJULuHyvxX7MJcI/Iru0OfMSEAACpiFoOQDjVmh5K9nvT5cSpyQS4R2RXixNfAnjUiD4BU8ut6afKSUKxzG4qLU76GAYHDwAMPNZ41flBObFqLgEdkfl2gAc14ihBejzdtNycblpuJon7CIgVaDBC/lHZazaevZLOVgXmARTemGiqNd2jebwnvaeT001/O88x0JWX2ZgxAGDITLiaewIA7lO3CNLb683tZL83zeAjhabo0+rpUXMJIGCnur3StBQrppvKZaIa0V1m49XcFEgEPds2Ml7NPQFmaLA7uzWi38z6qNsEuEdkFzHeKRASzpr1U3NTQA/vyWRzg93ZnR/8PtWlnI0xZtafbgJ8YZnNOq066/SImE7OhNw/mXVVt1OgAKZJRVp8sxzTek9AjphGWFo8NBvwZcpxUHdrAIAlAAsAJmzAJ+U89gKBQCAQrKL7T7Amd4I3uQbgMsDTYBpPhDzfmnVQ7wnQctbO2cFYaO+CUYN63wlq6cvCfr4jcmmfvuoqWy0BAGEHMX3eEZF3G1OvY25+GvNbAPVqLk8kgp6Dej7qOgE3YCZ/ZO49BobVYpLQEx/0nCtlujWmABHHA+7DBEypxazQs3qmWyMBAEDECuH9Qhk/ome2dRIAoMGeK/xNzrhDz6Zm/wf4wvI/AG5ba7scuW3fDdz7bymb61mHRFDUIt09TNX/CRJwlYEFBr6SFB6Lv9z2i0HLPwHes9ZayUhdQOm/vqwoXaRe1gl/6EWp+hRgYDuAhwg4zBJd9IflYz1HvzHw5Cna1XsYzMXfWswkUeFbAEwl3wDAxq8BDgaGl27f+ZluEpjGCwXU6xudP7ZuEpipIyIfh6akTlDGb9HVsJnfAh8mgp43dGJPANAUSzGVYxx3ZBAFgIwD+/N3XjN4nIkHPU/qdaLqG6EHP/21xb6idINzR0HkV13KMints4E9F4vZdp36eVcW9vMg7DATk4Ar2ayt8/tX79EtlVV9Clx44e7FRHD3F4sZelhzqMFOLL1UyjYW2rvAEj8Nxl9G4xFwRSF+xsjggQ1cA+Ze86zcUs8HntCzmw20zdiR7QQwoadLwJls1tY5G2ibMdqvDd0HpHKZaKPNqRYZqufnv+8P+sOXDjCk5xh8gIA7AYCB3wk0TVDG48G2abN9qjgB2g1Lumm5+YfnH7hWqd/1yA/Q9CBLUfEUYOCyuu263ri/mK4V9XyrsWANoMLdmULvek8nnVotq+r5VlPxa9B3au4+EF8AYFM5jTH4yNoZnqL1fOD+maBnU2t7luwDfGH5BIBXTAVmGomH3K9bEb8SLHkNplrTQwB/bdiggnq+1ViSgGS/N51qzRwC4QRWDzAXo+J6vtVYvhX2j8peZgzkDy3eON6OtXr+Js95gUAgEAgEgjX+Axe2kswAiZejAAAAAElFTkSuQmCC" />
                                                        Ventos {previsao[key].tarde.int_vento}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ 
                                            height: "250px",
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'space-evenly'
                                        }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                <div><img width="80px" src={`${previsao[key].icone}`}></img></div>

                                                <div>
                                                    <div className="text"><b>{previsao[key].dia_semana}</b></div>
                                                    <div className="min-max">
                                                        <img style={{ width: '30px', marginRight: '-10px', transform: 'rotate(180deg)' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAABmJLR0QA/wD/AP+gvaeTAAACE0lEQVR4nO3Xu2sUURgF8PPdCeujkIgEkspiNxEhzZqd6IaAjX+BjaAIirhJ/oR0ESzFYiE4u8WGQMTOQtFC7CQIeRQWCu5dURAsBIsUgq5kPoukGMOMz5l7g5xft/fO/fZw9jkAERERERERERERERXqdNMe8Z0BAIzXZ19QMxHZle0StmpRtwVV8RnHaxkTw72bAlzaeSSNWrs37zOPt1cijLpXFdLZs6yiuLw+N3rXRyYvZYRte1ZjPAFQStn+ApVzG3OVVde5nJdxarF7MghkVYGjP7nskzFmaq1R7joLBsffGdWOHTKBPPxFEQBwLI7jx9WOHXISbJezMuq33x8a6OMBgPJvHikHfb1fadoDReZKclPGgppvh7+uKHDmzw7K9GAJy65+cp2UURvp3QL0/F8evxBGb27kGihD4Y2Hd3rXVbT9r3NU5MrmTGU5j0xZCi1jMrL1GHgGIMhhXN8gnlybPfEih1mpCv2YxKLTyKcIAChtQ+o5zUo1UORwhS4JTBUaVwCz9cPmTlEHU459hsrzPdcOAngFCe4VFhYe/47XWvYdFMdTtl5uzI6OOw8E33et+wzLSGAZCSwjgWUksIwElpHgrwxFnLGTtV44n+8Mm7H+2mmKBG9lqGgzddloy3mYXd7K2JwZewTFNQE+AgAUH6Bycb0x9tRXpn0hXHw77DsDERERERERERER0f/uOxD7gnKnWy8VAAAAAElFTkSuQmCC"></img>
                                                        {previsao[key].temp_min}°
                                                        <img style={{ width: '30px', marginRight: '-10px' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAABmJLR0QA/wD/AP+gvaeTAAACEklEQVR4nO3XvWtTURzG8e+5t9YWRHSQGhUc6iK4uKipuergEpssggiKoIj+D24VHJ3c6lApVNwcSqMgbknooIuDghZBEJK20qGgUEp7fy6lXOUW33LPKfJ8xt95ycNzyRuIiIiIiIiIiIiISKGWqid3h84AEIV8cRsjmq8lU6vxjuX5emXcwIXME7SM7uvknmFXAcy4vTCa3AmZJ9iT6NYqN4CJn8Zm2LUDM+3HITIFKaNbT85i9gLoz1leSSN3/uB0s+07l/cyOqNnjjqXtoG9W+9yS+upjRx61vrgLRiey+hWk3302SzG8C83Oz6y5sql580vHqIBHj9AP18qDxLb9G8VAWAME9vTuWp1Z8HRNnkpw8aI+lbiKeDUHx6t7Iq/Tvr6yvVSxsKr0/cxLv7dabs8X0/u9jZRvsIb79SSWw57+M8XmV0vNdqTPYi0pULLWKiNlFOiJhD34LrVCE4MzbTe9OCuXIW+TVLiCr0pAqB/HSv36K5cfUVebi5+RLp23Dl3xLDl7JqDCjCQc+ybwewPe409ON4NrAw+KTJvyJ/jn4DDOUtvSzOtY77zQOA/atuNyshQGRkqI0NlZKiMDJWREbKMNHfqtph7EKwMh5vLXTDee46yKVgZZjzIG0fGuPcwG4KVUWo0G864CSxujDrO3JWhRutlqEzbwuKFc/tDZxARERERERERERH5330H6cWGuszNy3AAAAAASUVORK5CYII="></img>
                                                        {previsao[key].temp_max}°
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="resumo"><b>{previsao[key].resumo}</b></div>
                                            
                                            <hr width="90%"></hr>
                                            
                                            <div className="umidade-vento">
                                                <div className="umidade">
                                                    <img style={{ width: '16px', paddingRight: '5px' }} src="data:image/png;base64,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" />
                                                    Min: {previsao[key].umidade_min}% - Max: {previsao[key].umidade_max}%
                                                </div>

                                                <div className="vento">
                                                    <img style={{ width: '17px' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEs0lEQVR4nO2aS2wbVRSG/zN+JVGo0kiVWFAo1E6pTHgodppGogRCKFSCZQQbJBSIbUAgBUTUBVUFC0olHopa1Y6CWEbqig2PpiHQSMhO7YgKYag6CQQqWBSJRpDGjR9zWMRpx9PYM2OPEzvcb3fPnMe9Z+beuTPnAgKBQCAQCP6v0GZ3QI+OyHy7pPCLTNwLYFdevMCgSWKMJULuHyvxX7MJcI/Iru0OfMSEAACpiFoOQDjVmh5K9nvT5cSpyQS4R2RXixNfAnjUiD4BU8ut6afKSUKxzG4qLU76GAYHDwAMPNZ41flBObFqLgEdkfl2gAc14ihBejzdtNycblpuJon7CIgVaDBC/lHZazaevZLOVgXmARTemGiqNd2jebwnvaeT001/O88x0JWX2ZgxAGDITLiaewIA7lO3CNLb683tZL83zeAjhabo0+rpUXMJIGCnur3StBQrppvKZaIa0V1m49XcFEgEPds2Ml7NPQFmaLA7uzWi38z6qNsEuEdkFzHeKRASzpr1U3NTQA/vyWRzg93ZnR/8PtWlnI0xZtafbgJ8YZnNOq066/SImE7OhNw/mXVVt1OgAKZJRVp8sxzTek9AjphGWFo8NBvwZcpxUHdrAIAlAAsAJmzAJ+U89gKBQCAQrKL7T7Amd4I3uQbgMsDTYBpPhDzfmnVQ7wnQctbO2cFYaO+CUYN63wlq6cvCfr4jcmmfvuoqWy0BAGEHMX3eEZF3G1OvY25+GvNbAPVqLk8kgp6Dej7qOgE3YCZ/ZO49BobVYpLQEx/0nCtlujWmABHHA+7DBEypxazQs3qmWyMBAEDECuH9Qhk/ome2dRIAoMGeK/xNzrhDz6Zm/wf4wvI/AG5ba7scuW3fDdz7bymb61mHRFDUIt09TNX/CRJwlYEFBr6SFB6Lv9z2i0HLPwHes9ZayUhdQOm/vqwoXaRe1gl/6EWp+hRgYDuAhwg4zBJd9IflYz1HvzHw5Cna1XsYzMXfWswkUeFbAEwl3wDAxq8BDgaGl27f+ZluEpjGCwXU6xudP7ZuEpipIyIfh6akTlDGb9HVsJnfAh8mgp43dGJPANAUSzGVYxx3ZBAFgIwD+/N3XjN4nIkHPU/qdaLqG6EHP/21xb6idINzR0HkV13KMints4E9F4vZdp36eVcW9vMg7DATk4Ar2ayt8/tX79EtlVV9Clx44e7FRHD3F4sZelhzqMFOLL1UyjYW2rvAEj8Nxl9G4xFwRSF+xsjggQ1cA+Ze86zcUs8HntCzmw20zdiR7QQwoadLwJls1tY5G2ibMdqvDd0HpHKZaKPNqRYZqufnv+8P+sOXDjCk5xh8gIA7AYCB3wk0TVDG48G2abN9qjgB2g1Lumm5+YfnH7hWqd/1yA/Q9CBLUfEUYOCyuu263ri/mK4V9XyrsWANoMLdmULvek8nnVotq+r5VlPxa9B3au4+EF8AYFM5jTH4yNoZnqL1fOD+maBnU2t7luwDfGH5BIBXTAVmGomH3K9bEb8SLHkNplrTQwB/bdiggnq+1ViSgGS/N51qzRwC4QRWDzAXo+J6vtVYvhX2j8peZgzkDy3eON6OtXr+Js95gUAgEAgEgjX+Axe2kswAiZejAAAAAElFTkSuQmCC" />
                                                    Ventos {previsao[key].int_vento}
                                                </div>
                                            </div>
                                        </div>
                                    )}
    
                                </>
    
                            ))}
                        </Carousel>
    
                    </CarouselStyle>
    
                ) : (
                    <><p style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontSize: "12px", color: "#8A92A2", textAlign: "center"}}>Não foi possível carregar os dados. Aguarde alguns minutos e tente recarregar a página.</p></>
                )
            )}
        </Card>
    )
}

export default Week;

